import React from "react";
import {ContentSet, MAX_NUM_ITEMS} from "./contentset";
import ContentFinder, { getEmptyFinderState } from "./contentfinder";
import { ContentSetLink } from "./contentsetlink";
import ContentAudio from './content-audio/contentaudio';
import { ContentSetData, FinderState, ContentSetActions, ContentStatus } from "../../types/content.types";

const DEFAULT_AUDIO_VOICE:number=2; // US male

interface PropsType{
    usermail:string;
    isEdited:boolean;
    isContentSetNew:boolean;
    contentStatus:ContentStatus;
    userContentList:string[];
    contentSetData:ContentSetData;
    updateContentSet:(contentSetData: ContentSetData) => void;
    contentSetMenuClick:(contentSetAction: ContentSetActions, contentSet:string) => void;
}

interface StateType{
    finderState:FinderState;
    showHelper:boolean;
}

export const getEmptyContentData = function():ContentSetData{
    return {title:'', imsList:[],  txtsList:[], options:[{optID:'audio',optVal:DEFAULT_AUDIO_VOICE}], myID:-1}
}

export default class ContentOne extends React.Component<PropsType>{

    public state:StateType;

    constructor(props:PropsType){
        super(props);

        this.contentSetMenuClick=this.contentSetMenuClick.bind(this);
        this.contentFinderClick=this.contentFinderClick.bind(this);
        this.removeItemClick=this.removeItemClick.bind(this);
        this.contentSetItemTextChange=this.contentSetItemTextChange.bind(this);
        this.updateContentSetTitle=this.updateContentSetTitle.bind(this);
        this.selectAudio=this.selectAudio.bind(this);
        this.updateFinderState=this.updateFinderState.bind(this);

        this.state={
            finderState:getEmptyFinderState(),
            showHelper:true
        }
    }

    contentSetMenuClick(contentSetAction:ContentSetActions){
        this.props.contentSetMenuClick(contentSetAction,this.props.contentSetData.title);
    }

    contentFinderClick(itemCode:string,itemText:string){
        if(this.props.contentSetData.imsList.length>=MAX_NUM_ITEMS)return;
        if(this.props.contentSetData.imsList.indexOf(itemCode)===-1){
            let newContentSetData = {
                ...this.props.contentSetData,
                imsList: [...this.props.contentSetData.imsList, itemCode],
                txtsList: [...this.props.contentSetData.txtsList, itemText]
            };
            this.props.updateContentSet(newContentSetData);
        }
    }

    updateFinderState(finderState:FinderState){
        this.setState({finderState:finderState});
    }

    resetFinderState(){
        this.setState({finderState:getEmptyFinderState()});
    }

    contentSetItemTextChange(itemIndex:number, itemText:string){
        this.setState({showHelper:false});
        let cleanText = itemText.replace(/[^a-zA-Z0-9'?!&,.@ ]/g, "");
        let newTxtsList = [...this.props.contentSetData.txtsList];
        newTxtsList[itemIndex] = cleanText;
        let newContentSetData = {
            ...this.props.contentSetData,
            txtsList: newTxtsList
        };
        this.props.updateContentSet(newContentSetData);
    }

    removeItemClick(delItem:string){
        let delItemIndex=this.props.contentSetData.imsList.indexOf(delItem);
        if(delItemIndex!==-1){
            let newContentSetData = {
                ...this.props.contentSetData,
                imsList: this.props.contentSetData.imsList.filter((_, index) => index !== delItemIndex),
                txtsList: this.props.contentSetData.txtsList.filter((_, index) => index !== delItemIndex)
            };
            this.props.updateContentSet(newContentSetData);
        }
    }

    updateContentSetTitle(newTitle:string){
        let cleanText = newTitle.replace(/ /g, "_");
        cleanText = cleanText.replace(/[^a-zA-Z0-9_]/g, "");
        let newContentSetData = {
            ...this.props.contentSetData,
            title: cleanText
        };
        this.props.updateContentSet(newContentSetData);
    }

    selectAudio(audioIndex:number){
        let newOptions = this.props.contentSetData.options.map(option =>
            option.optID === 'audio' ? { ...option, optVal: audioIndex } : option
        );
        let newContentSetData = {
            ...this.props.contentSetData,
            options: newOptions
        };
        this.props.updateContentSet(newContentSetData);
    }

    render(): React.ReactNode {
        let showAll=true;
        if(this.props.contentStatus===ContentStatus.GetSet)showAll=false;
        if(this.props.contentStatus===ContentStatus.SaveSet)showAll=false;
        if(this.props.contentStatus===ContentStatus.DeleteSet)showAll=false;

        let showVoice=showAll&&this.props.contentSetData.imsList.length>=5;

        let audioChosen=1;
        for(let i=0;i<this.props.contentSetData.options.length;i++){
            if(this.props.contentSetData.options[i].optID==='audio'){
                audioChosen=this.props.contentSetData.options[i].optVal;
            }
        }

        return(
            <div className='teachers-content-one'>
                <ContentFinder
                    finderState={this.state.finderState}
                    updateFinderState={this.updateFinderState}
                    isContentSetNew={this.props.isContentSetNew}
                    contentSetDataImsList={this.props.contentSetData.imsList}
                    showFinder={showAll}
                    contentFinderClick={this.contentFinderClick}/>
                <ContentSet
                    showAll={showAll}
                    isLoggedIn={this.props.usermail!==''}
                    contentSetItemTextChange={this.contentSetItemTextChange}
                    userContentList={this.props.userContentList}
                    removeItemClick={this.removeItemClick}
                    contentSetMenuClick={this.contentSetMenuClick}
                    contentStatus={this.props.contentStatus}
                    updateContentSetTitle={this.updateContentSetTitle}
                    contentSetData={this.props.contentSetData}
                    isContentSetNew={this.props.isContentSetNew}
                    showHelper={this.state.showHelper && this.props.userContentList.length === 0}/>
                <ContentAudio
                    showVoice={showVoice}
                    txtsList={this.props.contentSetData.txtsList}
                    audioChosen={audioChosen}
                    selectAudio={this.selectAudio}/>
                <ContentSetLink
                    contentStatus={this.props.contentStatus}
                    usermail={this.props.usermail}
                    contentSetData={this.props.contentSetData}
                    isEdited={this.props.isEdited}/>
            </div>
        );
    }
}
